// export const BASE_HREF = "/centura/site-portal";
// export let BASE_URL = "https://developer-beta.com/p7/centura_churchill/api"
// export let BASE_IMAGE_URL = "https://developer-beta.com/p7/centura_churchill/"
// export let BASE_FONT_URL = "https://developer-beta.com/"



export const BASE_HREF = "/";
export let BASE_URL = "https://rcacapacitors.com/admin/api"
export let BASE_IMAGE_URL = "https://rcacapacitors.com/admin/"
export let BASE_FONT_URL = "https://rcacapacitors.com/"